import { DatePicker, Form, Input, InputNumber, Select } from 'antd'
import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import InputField from '../common/Input/InputField'
import SelectField from '../common/Select/SelectField'
import dayjs from 'dayjs'
import { OPTIONS_ROLE, OPTIONS_STATUS_SELECTION } from '../../configData'
import { userSearch } from '../../services/cmsservice'
import openNotification from '../common/Notification/openNotification '
import { removeVietnameseTones } from '../../config-func'
const customizeRequiredMark = (label, { required }) => (
  <>
    {label}
    {required && <span style={{ color: 'red' }}> *</span>}
  </>
)
const FormPost = ({ data, form, handleSearch, listCategory, mode }) => {
  useEffect (() => {
    if(data) {
      form.setFieldsValue(data)
    }
  }, [data])
  return (
    <Form
      form={form}
      onFinish={handleSearch}
      labelAlign="left"
      labelCol={{ span: 7 }}
      layout="horizontal"
      style={{
        marginTop: 10,
        overflow: 'auto',
        overflowX: 'hidden',
        padding: '0px 10px'
      }}
      requiredMark={customizeRequiredMark}
      disabled={mode == 'VIEW' ? true : false}
    >
      <Form.Item label="" name="id" style={{ display: 'none' }}>
        <Input />
      </Form.Item>
      <Form.Item
        label="Catergory"
        name="category"
        rules={[{ required: true, message: 'Vui lòng nhập category' }]}
        className={styles.formItem}
      >
        <Select
          style={{ width: '100%' }}
          placeholder="Chọn category"
          options={listCategory?.map((item) => ({
            label: item.title,
            value: item.value
          }))}
        />
      </Form.Item>
      <Form.Item
        label="Code"
        name="value"
        rules={[{ required: true, message: 'Vui lòng nhập code' }]}
        className={styles.formItem}
      >
        <Input placeholder="Nhập code" />
      </Form.Item>
     
      <Form.Item
        label="Value"
        name="title"
        rules={[{ required: true, message: 'Vui lòng nhập value' }]}
        className={styles.formItem}
      >
        <Input placeholder="Nhập value" />
      </Form.Item>
      <Form.Item
        label="Order"
        name="order"
        rules={[{ required: true, message: 'Vui lòng nhập order' }]}
        className={styles.formItem}
      >
        <InputNumber placeholder="Nhập order" min={0} style={{ width: '100%' }} />
      </Form.Item>

      {/* <Form.Item label="Trạng thái" name="status" className={styles.formItem}>
        <Select
          style={{ width: '100%' }}
          placeholder="Chọn trạng thái"
          options={OPTIONS_STATUS_SELECTION?.map((item) => ({
            label: item.name,
            value: item.value
          }))}
        />
      </Form.Item> */}
    </Form>
  )
}

export default FormPost
